import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';

import { MessageService } from 'primeng/api';

// --- config import ---
import { NTAPCommonModule } from '@ntap/common';
import { CoreConfig, CoreConfigService } from '@ntap/core';
import { AppConfig } from './app-config.interface';
import { appConfigService } from './app-config.service';
import { SettingsConfigHttpService } from './settings-config-http.service';
import { SettingsConfigService } from './settings-config.service';

// --- START externalized configuration ---
// ----------------------------------------
// for local development see ./src/assets/settings.json
// for docker deployment see ./src/assets/settings.template.json
const config: AppConfig = {
  apiHost: '',
  waybackHost: '',
  crawlingApiHost: '',
  portalBlHost: '',
  wsHost: ''
};

export function appInitializerFn(
  config_: AppConfig,
  ntapConfig: CoreConfig,
  settingsConfigHttpService: SettingsConfigHttpService
): () => Promise<string> {
  return (): Promise<string> =>
    new Promise((resolve, reject) => {
      settingsConfigHttpService
        .loadAppConfig()
        .then(() =>
          SettingsConfigService.setConfig(
            config_,
            ntapConfig,
            settingsConfigHttpService
          )
        )
        .then(() => {
          resolve('Success');
        })
        .catch(() => {
          reject();
        });
    });
}

@NgModule({})
export class ConfigModule {
  static forRoot(
    ntapConfig: CoreConfig
  ): ModuleWithProviders<NTAPCommonModule> {
    return {
      ngModule: NTAPCommonModule,
      providers: [
        { provide: appConfigService, useValue: config },
        SettingsConfigHttpService,
        { provide: CoreConfigService, useValue: ntapConfig },
        {
          provide: APP_INITIALIZER,
          useFactory: appInitializerFn,
          multi: true,
          deps: [appConfigService, CoreConfigService, SettingsConfigHttpService]
        },
        MessageService
      ]
    };
  }
}
